import { ModelResource } from './resource';
import { ClaimLineItem } from '../models';

export class ClaimLineItems extends ModelResource<ClaimLineItem> {
  model = ClaimLineItem;

  resourcePath = 'v1/deductions/claim-line-items';

  async update(id: string, data, claimLineItem?: ClaimLineItem) {
    const response = await this.api.patch(this.path(id), {
      data,
    });

    if (claimLineItem) {
      claimLineItem.updateFromJson(response.data);
    } else {
      claimLineItem = ClaimLineItem.fromJson(response.data);
    }

    return claimLineItem;
  }

  async approve(id: string, claimLineItem?: ClaimLineItem) {
    const response = await this.api.patch(this.path(id), {
      data: { approval_status: 'approved' },
    });

    if (claimLineItem) {
      claimLineItem.updateFromJson(response.data);
    } else {
      claimLineItem = ClaimLineItem.fromJson(response.data);
    }

    return claimLineItem;
  }

  async reject(id: string, claimLineItem?: ClaimLineItem) {
    const response = await this.api.patch(this.path(id), {
      data: { approval_status: 'rejected' },
    });

    if (claimLineItem) {
      claimLineItem.updateFromJson(response.data);
    } else {
      claimLineItem = ClaimLineItem.fromJson(response.data);
    }

    return claimLineItem;
  }

  async clear(id: string, claimLineItem?: ClaimLineItem) {
    const response = await this.api.patch(this.path(id), {
      data: { approval_status: 'pending' },
    });

    if (claimLineItem) {
      claimLineItem.updateFromJson(response.data);
    } else {
      claimLineItem = ClaimLineItem.fromJson(response.data);
    }

    return claimLineItem;
  }
}
